import React, { createContext, FC, useEffect } from 'react'
import io, { Socket } from 'socket.io-client'

const ENDPOINT = import.meta.env.VITE_BASE_URL

type Props = {
    children: React.ReactNode
}

type SocketContextType = {
    socket: Socket
}

export const SocketContext = createContext({} as SocketContextType)

export const SocketProvider: FC<Props> = ({ children }) => {
    const [socket, setSocket] = React.useState<Socket | null>(null)

    useEffect(() => {
        const connection = io(ENDPOINT)

        connection.on('connect_error', err => {
            console.error(err)
        })

        connection.on('disconnect', reason => {
            console.warn(reason)
        })

        setSocket(connection)

        return () => {
            connection.disconnect()
        }
    }, [])

    if (!socket) {
        return null
    }

    return (
        <SocketContext.Provider value={{ socket }}>
            {children}
        </SocketContext.Provider>
    )
}
